module.exports = __webpack_public_path__ + "img/Insights.1352e244.svg";